import { Component, computed, inject } from '@angular/core';
import { UtilityService } from '@eforall/common';
import { GridContentWidget, PageTabsMainTabGridSize } from '@eforall/dashboard';
import { AppService } from '../../../../../services';
import { DevoDonorsPageService } from '../../devo-donors.page.service';
import { getSetup } from './grid/get-setup';


@Component({
	selector: 'devo-donors-contacts-view-part',
	standalone: true,
	imports: [GridContentWidget],
	templateUrl: './devo-donors-contacts-view.part.html',
})
export class DevoDonorsContactsViewPart {

	private readonly util = inject(UtilityService);
	private readonly app = inject(AppService);
	private readonly pageService = inject(DevoDonorsPageService);
	public setup = getSetup(this.util);

	public pageTabsGridSize = computed<PageTabsMainTabGridSize | undefined>(() => {
		if (this.pageService.layout()) return { layout: this.pageService.layout()!, viewSelector: true };
		return undefined;
	});

	public contacts = computed(() => { return []; });

}